import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const auditLogsRoutes: RouteRecordRaw[] = [
  {
    path: '/audit-logs',
    name: 'audit-logs',
    component: () => import('./views/AuditLogsView.vue'),
    meta: {
      title: () => i18next.t('nav.auditLogs'),
      requiredEntitlement: 'AUDIT_LOG',
    },
  },
];
